import { useEffect, useState } from 'react';

import { AuthProvider } from '../services/AuthService/Types';
import { fetchAuthProviders } from '../services/AuthService/utilities';

interface Props {
  appKey?: string;
  orgKey?: string;
}

interface ReturnType {
  isFetching: boolean;
  loginEnabledProviders: AuthProvider[];
  providers: AuthProvider[];
}

export default function useAuthProviders({
  appKey,
  orgKey,
}: Props): ReturnType {
  const [isFetching, setIsFetching] = useState(true);
  const [providers, setProviders] = useState<AuthProvider[]>([]);
  const [loginEnabledProviders, setLoginEnabledProviders] = useState<
    AuthProvider[]
  >([]);

  useEffect(() => {
    if (!appKey && !orgKey) {
      setIsFetching(false);

      return;
    }

    setIsFetching(true);

    const doFetch = async () => {
      try {
        const result = await fetchAuthProviders({ appKey, orgKey });
        setProviders(result);
        setLoginEnabledProviders(
          result.filter((provider) => provider.enable_login)
        );
      } finally {
        setIsFetching(false);
      }
    };

    doFetch();
  }, [appKey, orgKey]);

  return {
    isFetching,
    loginEnabledProviders,
    providers,
  };
}
